module.exports = __webpack_public_path__ + "img/图片29.0ff59d56.png";